import React, { useEffect, useState } from 'react';
import ModalFull from 'components/Tvendo/Common/ModalFull';
import { wsGetPdf } from 'services/WService';
import LoadingSpinner from './LoadingSpinner';

function PdfModal(props) {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const { title, src, onClose, id = '' } = props;

  useEffect(() => {
    if (props.open === true) {
      setOpen(true);
    }
  }, [props.open]);

  async function loadPdf() {
    setLoading(true);
    await wsGetPdf('#pdf-iframe' + id, src, () => {
      alert('No se encontró el pdf');
      setOpen(false);
      if (onClose !== undefined) {
        onClose();
      }
    });
    setLoading(false);
  }

  useEffect(() => {
    if (src !== undefined) loadPdf();
  }, [src]);

  return (
    <ModalFull
      title={title}
      open={open}
      setOpen={() => {
        setOpen((open) => {
          if (open === true) {
            if (onClose !== undefined) {
              onClose();
            }
            return false;
          }

          return true;
        });
      }}
      iframe
    >
      {loading && (
        <div
          style={{
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            marginTop: '200px',
          }}
        >
          <LoadingSpinner styles={{ width: '150px', height: '150px', borderWidth: '20px' }} />
        </div>
      )}
      <iframe
        width="100%"
        height="100%"
        id={"pdf-iframe" + id}
        style={{ display: loading ? 'none' : 'block' }}
      >
        No se pudo cargar el contenido.
      </iframe>
    </ModalFull>
  );
}

export default PdfModal;
